import { type ChatAction, type ChatState } from "@/types"

export const initialState: ChatState = {
  messages: [],
  isLoading: false,
  error: null,
  threadId: null,
}

export function chatReducer(state: ChatState, action: ChatAction): ChatState {
  switch (action.type) {
    case "ADD_MESSAGE":
      return {
        ...state,
        messages: [...state.messages, action.payload],
        error: null,
      }

    case "SET_MESSAGE_VOTE": {
      const { id, wasHelpful } = action.payload
      return {
        ...state,
        messages: state.messages.map((msg) =>
          msg.id === id && msg.type === "text" ? { ...msg, wasHelpful } : msg,
        ),
      }
    }

    case "SET_MESSAGE_SUGGESTIONS": {
      const { serverId, chips } = action.payload
      return {
        ...state,
        messages: state.messages.map((msg) =>
          msg.type === "text" && msg.serverId === serverId
            ? { ...msg, suggestions: chips }
            : msg,
        ),
      }
    }

    case "SET_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      }

    case "SET_ERROR":
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }

    case "CLEAR_MESSAGES":
      return {
        ...state,
        messages: [],
        error: null,
        threadId: null,
      }

    case "SET_THREAD_ID":
      return {
        ...state,
        threadId: action.payload,
      }

    default:
      return state
  }
}
